import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { putRequest } from '../../../requestUtils';
import { ABOUT_TEXT_SUGGESTION, IDEAL_CANDIDATE_SUGGESTION } from '../../../constants';
import { sanitizeResponsibilityHtml, responsibilitiesToListElements, sanitizeOnChangeValue, formatIdealCandidateOnLoad } from '../../../responsibilitiesUtils';
import ContentEditableComponent from '../../common/ContentEditableComponent';
import '../ProjectDetails.scss';
var MAX_RESPONSIBILITIES = 4; // the maximum number of responsibilities

var respArray = [{
  description: ''
}, {
  description: ''
}];
var formStep = 'responsibilities';
var ProjectResponsibilities = /*#__PURE__*/function (_Component) {
  function ProjectResponsibilities(props) {
    var _this;
    _classCallCheck(this, ProjectResponsibilities);
    _this = _callSuper(this, ProjectResponsibilities, [props]);
    _this.state = {
      showModal: false,
      errors: null,
      responsibilities: respArray,
      numResponsibilities: respArray.length,
      // the number of active responsibilities (starts at 2)
      description: '',
      idealCandidateDescription: '',
      responsibilityAreas: '',
      status: '',
      descriptionDefault: false,
      idealCandidateDefault: false,
      isSaving: false
    };
    _this.setResp = _this.setResp.bind(_this);
    _this.handleShowModal = _this.handleShowModal.bind(_this);
    _this.handleHideModal = _this.handleHideModal.bind(_this);
    _this.handleBack = _this.handleBack.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.addResp = _this.addResp.bind(_this);
    _this.removeResp = _this.removeResp.bind(_this);
    _this.validResponsibilities = _this.validResponsibilities.bind(_this);
    _this.handleClearSuggestions = _this.handleClearSuggestions.bind(_this);
    _this.validateFormInput = _this.validateFormInput.bind(_this);
    return _this;
  }
  _inherits(ProjectResponsibilities, _Component);
  return _createClass(ProjectResponsibilities, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var _this$props = this.props,
        projectResourceId = _this$props.projectResourceId,
        getProjectDetails = _this$props.getProjectDetails;
      if (!projectResourceId) return;
      getProjectDetails(formStep).then(function (_ref) {
        var data = _ref.data;
        var responsibilitieslength = data.responsibility_areas.length;
        _this2.setState({
          status: data.status,
          descriptionDefault: data.status === 'employer_draft' && data.description === null,
          idealCandidateDefault: data.status === 'employer_draft' && formatIdealCandidateOnLoad(data.ideal_candidate_description) === null,
          description: data.description || ABOUT_TEXT_SUGGESTION,
          idealCandidateDescription: formatIdealCandidateOnLoad(data.ideal_candidate_description) || IDEAL_CANDIDATE_SUGGESTION,
          numResponsibilities: responsibilitieslength || respArray.length,
          responsibilities: responsibilitieslength ? data.responsibility_areas : respArray,
          responsibilityAreas: responsibilitiesToListElements(data.responsibility_areas) || '<li></li>'
        });
      });
    }
  }, {
    key: "setResp",
    value: function setResp(e, index) {
      var responsibilities = this.state.responsibilities;
      var newResp = responsibilities;
      newResp[index] = {
        description: e.target.value,
        id: e.target.dataset.id
      };
      this.setState({
        responsibilities: newResp
      });
    }
  }, {
    key: "handleDescriptionChange",
    value: function handleDescriptionChange(value) {
      this.setState({
        errors: null,
        description: value
      });
    }
  }, {
    key: "handleListChange",
    value: function handleListChange(event, inputName) {
      var original = String(event.target.value);

      // Sanitize the input before passing to sanitizeOnChangeValue
      var value = sanitizeOnChangeValue(original.replace(/&amp;/g, '&'));
      var newLength = value.length;
      // Check the length and apply additional transformations
      if (newLength > 0) {
        // Add <li> tags for bullet points if necessary
        if (!value.startsWith('<li>') && !value.endsWith('</li>')) {
          value = "<li>".concat(value, "</li>");
        }
      }
      this.setState(_defineProperty(_defineProperty({}, inputName, value), "errors", null));
    }
  }, {
    key: "handleClearSuggestions",
    value: function handleClearSuggestions(inputName) {
      if (inputName === 'description') {
        this.setState(_defineProperty({}, inputName, ''));
      } else {
        this.setState(_defineProperty({}, inputName, '<li></li>'));
      }
    }
  }, {
    key: "addResp",
    value: function addResp() {
      var _this$state = this.state,
        responsibilities = _this$state.responsibilities,
        numResponsibilities = _this$state.numResponsibilities;
      var newResp = [].concat(_toConsumableArray(responsibilities), [{
        description: ''
      }]);
      this.setState({
        responsibilities: newResp,
        numResponsibilities: numResponsibilities + 1
      });
    }
  }, {
    key: "removeResp",
    value: function removeResp(id, index) {
      var _this$state2 = this.state,
        responsibilities = _this$state2.responsibilities,
        numResponsibilities = _this$state2.numResponsibilities;
      var newResp = responsibilities;
      if (responsibilities.length < 3) {
        // if there are only 2 responsibilities
        newResp[index] = {
          description: '',
          id: id
        }; // clear them rather than delete them
      } else {
        newResp[index] = {
          _destroy: 'true',
          id: id
        };
        this.setState({
          numResponsibilities: numResponsibilities - 1
        });
      }
      this.setState({
        responsibilities: newResp
      });
    }
  }, {
    key: "validResponsibilities",
    value: function validResponsibilities() {
      var _this$state3 = this.state,
        responsibilities = _this$state3.responsibilities,
        numResponsibilities = _this$state3.numResponsibilities;
      var count = 0;
      if (numResponsibilities <= 1) return false;
      responsibilities.forEach(function (resp) {
        if (!(resp._destroy === 'true') && resp.description.length > 2) {
          count += 1;
        }
      });
      return count > 1;
    }
  }, {
    key: "validateFormInput",
    value: function validateFormInput() {
      var _this$state4 = this.state,
        description = _this$state4.description,
        idealCandidateDescription = _this$state4.idealCandidateDescription,
        responsibilityAreas = _this$state4.responsibilityAreas;
      var errors = {};
      [description, idealCandidateDescription, responsibilityAreas].forEach(function (input, i) {
        var inputNames = ['description', 'idealCandidateDescription', 'responsibilityAreas'];
        if (input.length < 100) {
          errors[inputNames[i]] = 'should be more than 100 characters';
        }
      });
      if (Object.keys(errors).length > 0) {
        this.setState({
          errors: errors
        });
        return true;
      }
      return false;
    }
  }, {
    key: "handleShowModal",
    value: function handleShowModal() {
      this.setState({
        showModal: true
      });
    }
  }, {
    key: "handleHideModal",
    value: function handleHideModal() {
      this.setState({
        showModal: false
      });
    }
  }, {
    key: "handleBack",
    value: function handleBack() {
      if (this.props.formType === 'page') {
        this.props.back();
      } else {
        this.handleHideModal();
      }
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var _this3 = this;
      var _this$props2 = this.props,
        csrfToken = _this$props2.csrfToken,
        projectResourceId = _this$props2.projectResourceId,
        afterSubmit = _this$props2.afterSubmit;
      var _this$state5 = this.state,
        responsibilities = _this$state5.responsibilities,
        description = _this$state5.description,
        idealCandidateDescription = _this$state5.idealCandidateDescription,
        responsibilityAreas = _this$state5.responsibilityAreas,
        isSaving = _this$state5.isSaving;
      if (isSaving) return;
      if (this.validateFormInput()) return;
      this.setState({
        isSaving: true,
        errors: null
      });
      // converting responsibilities from an array to a nested hash
      var respHash = {};
      responsibilities.forEach(function (responsibility, i) {
        if (responsibility) {
          respHash[i] = responsibility;
        }
      });
      var responsibilityAreaAttributes = sanitizeResponsibilityHtml(responsibilityAreas);
      putRequest("/projects/".concat(projectResourceId), {
        project: {
          ideal_candidate_description: idealCandidateDescription,
          responsibility_areas_attributes: responsibilityAreaAttributes,
          description: description
        }
      }, csrfToken).then(function () {
        afterSubmit();
      })["catch"](function (error) {
        _this3.setState({
          errors: error,
          isSaving: false
        });
      });
    }
  }, {
    key: "renderModal",
    value: function renderModal() {
      return /*#__PURE__*/React.createElement(Modal, {
        show: this.state.showModal,
        onHide: this.handleHideModal,
        dialogClassName: "project-resp-modal"
      }, /*#__PURE__*/React.createElement(Modal.Header, {
        closeButton: true
      }), /*#__PURE__*/React.createElement(Modal.Body, {
        className: "project-resp-modal-body"
      }, this.renderContent()));
    }
  }, {
    key: "renderButtons",
    value: function renderButtons() {
      var _this$props3 = this.props,
        backButtonText = _this$props3.backButtonText,
        submitButtonText = _this$props3.submitButtonText;
      var isSaving = this.state.isSaving;
      var disabledState = isSaving ? 'disabled' : '';
      return /*#__PURE__*/React.createElement("div", {
        className: "footer-buttons-container"
      }, /*#__PURE__*/React.createElement("button", {
        className: "btn btn-secondary button-back",
        onClick: this.handleBack
      }, backButtonText), /*#__PURE__*/React.createElement("button", {
        className: "btn btn-primary button-submit ".concat(disabledState),
        onClick: this.handleSubmit,
        disabled: isSaving
      }, isSaving ? 'Saving...' : submitButtonText));
    }
  }, {
    key: "renderErrors",
    value: function renderErrors() {
      var errors = this.state.errors;
      return errors && /*#__PURE__*/React.createElement("div", {
        id: "error_explanation"
      }, /*#__PURE__*/React.createElement("h3", null, "Errors prohibited this project from being saved:"), /*#__PURE__*/React.createElement("ul", null, errors.map(function (e) {
        return /*#__PURE__*/React.createElement("li", {
          key: e
        }, e);
      })));
    }
  }, {
    key: "renderResponsibilities",
    value: function renderResponsibilities() {
      var _this4 = this;
      var responsibilities = this.state.responsibilities;
      return responsibilities.map(function (responsibility, index) {
        if (responsibility._destroy === 'true') return null;
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
          className: "body-text-2 mb-2 mt-2"
        }, "Responsibility", ' ', index + 1, "\xA0\xA0", /*#__PURE__*/React.createElement("a", {
          className: "remove-resp",
          role: "button",
          tabIndex: 0,
          onClick: function onClick() {
            return _this4.removeResp(responsibility.id, index);
          }
        }, "\xD7Remove")), /*#__PURE__*/React.createElement("textarea", {
          name: "responsibility-input",
          className: "form-control fs-hide null",
          required: "required",
          "data-id": responsibility.id,
          onChange: function onChange(e) {
            _this4.setResp(e, index);
          },
          value: responsibility.description
        }));
      });
    }
  }, {
    key: "renderAddResponsibility",
    value: function renderAddResponsibility() {
      var _this5 = this;
      var numResponsibilities = this.state.numResponsibilities;
      if (numResponsibilities < MAX_RESPONSIBILITIES) {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("a", {
          className: "add-resp body-text-2 medium-weight mt-2",
          role: "button",
          tabIndex: 0,
          onClick: function onClick() {
            return _this5.addResp();
          }
        }, "+ Add another responsibility"), /*#__PURE__*/React.createElement("p", {
          className: "add-resp body-text-2 light-weight muted-gray-text mt-2"
        }, "\xA0\xA0(Maximum 4 responsibilities)"));
      }
      return null;
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var _this6 = this;
      var _this$state6 = this.state,
        description = _this$state6.description,
        idealCandidateDescription = _this$state6.idealCandidateDescription,
        responsibilityAreas = _this$state6.responsibilityAreas,
        errors = _this$state6.errors,
        descriptionDefault = _this$state6.descriptionDefault,
        idealCandidateDefault = _this$state6.idealCandidateDefault;
      var suggestionText = 'We\'ve added copy suggestions';
      return /*#__PURE__*/React.createElement("div", {
        className: "style-guide responsibility-container",
        key: this.state.numResponsibilities
      }, /*#__PURE__*/React.createElement("div", {
        className: "g-row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "g-column g-flex-1"
      }), /*#__PURE__*/React.createElement("div", {
        className: "g-column g-flex-60 responsibility-inputs"
      }, /*#__PURE__*/React.createElement("h2", {
        className: "header"
      }, "Description"), /*#__PURE__*/React.createElement(ContentEditableComponent, {
        title: "About This Project",
        description: "Provide a summary of the company and the role.",
        className: "job-description",
        handleOnChange: function handleOnChange(value) {
          return _this6.handleDescriptionChange(value);
        },
        handleClearSuggestions: function handleClearSuggestions() {
          return _this6.handleClearSuggestions('description');
        },
        showClearSuggestion: descriptionDefault,
        suggestionText: suggestionText,
        showError: errors && Object.keys(errors).includes('description'),
        value: description,
        requiredText: "* Required",
        errorMessage: errors ? errors.description : null,
        required: true
      }), /*#__PURE__*/React.createElement(ContentEditableComponent, {
        title: "Responsibilities",
        description: "Example: Manage and direct all clinical processes and\n                operations relating to clinical data management for clinical trials.",
        className: "responsibilities",
        handleOnChange: function handleOnChange(event) {
          return _this6.handleListChange(event, 'responsibilityAreas');
        },
        handleOnPaste: function handleOnPaste(event) {
          return _this6.handleOnPaste(event, 'responsibilityAreas');
        },
        handleClearSuggestions: function handleClearSuggestions() {
          return _this6.handleClearSuggestions('responsibilityAreas');
        },
        value: responsibilityAreas,
        showError: errors && Object.keys(errors).includes('responsibilityAreas'),
        errorMessage: errors ? errors.responsibilityAreas : null,
        requiredText: "* Required",
        withBulletPoints: true,
        required: true
      }), /*#__PURE__*/React.createElement(ContentEditableComponent, {
        title: "Ideal Consultant",
        description: "Describe the phenotype or attributes your ideal candidate needs for this role.",
        className: "ideal-candidate",
        handleOnChange: function handleOnChange(event) {
          return _this6.handleListChange(event, 'idealCandidateDescription');
        },
        handleClearSuggestions: function handleClearSuggestions() {
          return _this6.handleClearSuggestions('idealCandidateDescription');
        },
        handleOnPaste: function handleOnPaste(event) {
          return _this6.handleOnPaste(event, 'idealCandidateDescription');
        },
        value: idealCandidateDescription,
        showClearSuggestion: idealCandidateDefault,
        suggestionText: suggestionText,
        showError: errors && Object.keys(errors).includes('idealCandidateDescription'),
        errorMessage: errors ? errors.idealCandidateDescription : null,
        requiredText: "* Required",
        withBulletPoints: true,
        required: true
      }), this.renderButtons())));
    }
  }, {
    key: "renderModalLink",
    value: function renderModalLink() {
      return /*#__PURE__*/React.createElement("i", {
        role: "button",
        tabIndex: 0,
        className: "fa fa-edit modal-link",
        onClick: this.handleShowModal
      }, this.props.formType === 'modal-link' ? 'Edit' : '');
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.formType === 'page') {
        return this.renderContent();
      }
      return /*#__PURE__*/React.createElement("div", null, this.renderModalLink(), this.renderModal());
    }
  }]);
}(Component);
ProjectResponsibilities.propTypes = {
  formType: PropTypes.string,
  // one of 'page', 'modal-link', 'modal-icon'
  projectResourceId: PropTypes.string,
  csrfToken: PropTypes.string.isRequired,
  back: PropTypes.func,
  afterSubmit: PropTypes.func,
  getProjectDetails: PropTypes.func.isRequired,
  backButtonText: PropTypes.string,
  submitButtonText: PropTypes.string
};
ProjectResponsibilities.defaultProps = {
  formType: 'page',
  projectResourceId: null,
  back: function back() {},
  afterSubmit: function afterSubmit() {},
  backButtonText: 'Back',
  submitButtonText: 'Next'
};
export default ProjectResponsibilities;